function toFiniteNumber(value) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : 0;
}

function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

function isFalse(value) {
    return value === false || value === 0 || value === '0' || value === 'false';
}

export function isProjectVendorPlanningIncomplete(record = {}) {
    if (!record) {
        return false;
    }

    const estimatedVendorCost = toFiniteNumber(record.estimated_vendor_cost);
    const noEstimatedVendorCost = isTrue(record.no_estimated_vendor_cost) ||
        isTrue(record.noEstimatedVendorCost);

    if (noEstimatedVendorCost) {
        return false;
    }

    if (isTrue(record.vendor_planning_incomplete) || isTrue(record.vendorPlanningIncomplete)) {
        return true;
    }
    if (isFalse(record.vendor_planning_incomplete) || isFalse(record.vendorPlanningIncomplete)) {
        return false;
    }

    return estimatedVendorCost > 0 &&
        record.vendor_planning_completed === false;
}
